import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {Alert, Box, Button, Card, CardContent, CircularProgress, Container, Typography} from "@mui/material";
import {useEffect} from "react";
import {useAuth} from "react-oidc-context";
import {useNavigate} from "react-router-dom";

const Login = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Si ya existe un token almacenado, acceso directo a la app
    const storedToken = sessionStorage.getItem("token_TSE");
    if (storedToken) {
      navigate("/");
      return;
    }

    // Si el usuario acaba de autenticarse via OIDC, guardar token y redirigir
    if (auth.isAuthenticated && auth.user) {
      const token = auth.user.access_token;
      if (token) {
        sessionStorage.setItem("token_TSE", token);
        navigate("/");
      }
    }
  }, [auth.isAuthenticated, auth.user, navigate]);

  const handleLogin = () => {
    // Guardar la URL de retorno antes de redirigir a OpenID
    sessionStorage.setItem("returnUrl", "/");
    auth.signinRedirect();
  };

  if (auth.isLoading) {
    return (
      <Container maxWidth="sm">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            gap: 2
          }}
        >
          <CircularProgress />
          <Typography variant="body1" color="text.secondary">
            Cargando...
          </Typography>
        </Box>
      </Container>
    );
  }

  if (auth.error) {
    return (
      <Container maxWidth="sm">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            gap: 2
          }}
        >
          <Alert severity="error" sx={{width: "100%"}}>
            <Typography variant="h6" gutterBottom>
              Error de autenticación
            </Typography>
            <Typography variant="body2">{auth.error.message}</Typography>
          </Alert>
          <Button variant="contained" onClick={handleLogin} fullWidth>
            Intentar nuevamente
          </Button>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh"
        }}
      >
        <Card sx={{width: "100%", maxWidth: 400}}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 3,
                p: 2
              }}
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  backgroundColor: "primary.main",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <LockOutlinedIcon sx={{color: "white", fontSize: 32}} />
              </Box>

              <Typography variant="h4" component="h1" align="center">
                Iniciar Sesión
              </Typography>

              <Typography variant="body1" color="text.secondary" align="center">
                Haz clic en el botón para iniciar sesión con OpenID Connect
              </Typography>

              <Button
                variant="contained"
                fullWidth
                size="large"
                onClick={handleLogin}
                sx={{
                  mt: 2,
                  py: 1.5,
                  textTransform: "none",
                  fontSize: "1rem"
                }}
              >
                Iniciar Sesión con OpenID
              </Button>

              <Typography variant="caption" color="text.secondary" align="center" sx={{mt: 2}}>
                Serás redirigido a tu proveedor de identidad de forma segura
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default Login;
